import Ads from '~/common/js/ads.js';
import Choices from 'choices.js';
import RefineSearch from './modules/refine-filters.js';
import attachOnSelectChangeUrlHandler from './modules/search-result-sort.js';
import utils from './modules/utils.js';
import GliderCarousel from './modules/glider-carousel.js'
import DatePicker from './modules/date-picker.js';
import Header from './modules/header.js';
import RecentNotices from './modules/recent-notices.js';
import './modules/modal'
import FixedFeedbackButton from './FixedFeedbackButton';
import FeatureBar from './FeatureBar'
import Cards from '~/common/js/Cards'
import Responsive from '~/common/js/Responsive'

import {
  SHOW_REFINEMENT_CLASS,
  refineEl,
  drawerEl,
  refineCloseEl,
  searchInputEl,
  formExpandEl,
  mobileSearchTitleEl,
  mobileSearchInputEl,
  closeMobileFormEl,
  searchFormEl,
  searchIconEl,
  documentBodyEl,
  publicationEl
} from './modules/constants.js'

// Global Modules
import Cookies from 'js-cookie'
window.Cookies = Cookies

// @TODO: MYT Images
import '../images/background.jpg'
import '../images/modal-hero.jpg'
import '../images/mytributes-logo.svg'
import '../images/where-memories-live.svg'
import '../images/obituaries.jpg'
import '../images/favicon.svg'
import '../images/premium-ribbon.svg'
import '../images/this-page-no-longer-exists.svg'
import '../images/fallback1.jpg'
import '../images/fallback2.jpg'
import '../images/fallback3.jpg'
import '../images/fallback4.jpg'

export default function () {
  Ads()

  // Desktop carousel (if needed like with Related Notices)
  const desktopCarousEl = document.getElementById("glider-desktop");
  if(desktopCarousEl) {
    // Create Desktop Carousel
    const gliderArrowsEl = document.getElementsByClassName('glider__controller'),
          gliderDotsEl = document.querySelector('#dots'),
          gliderArrowPrev = document.querySelector('#glider__prev-control'),
          gliderArrowNext = document.querySelector('#glider__next-control'),
          topPickCardEl = document.getElementsByClassName('glider-slide'),
          showOnDesktop = true;

    new GliderCarousel(desktopCarousEl, gliderArrowsEl, gliderDotsEl, gliderArrowPrev, gliderArrowNext, topPickCardEl, showOnDesktop);
  }

  // Top Picks
  const topPicksEl = document.getElementById("glider-top");
  if(topPicksEl) {
    // Create Mobile Top Picks Carousel
    const gliderArrowsEl = document.getElementsByClassName('glider__controller'),
          gliderDotsEl = document.querySelector('#dots'),
          gliderArrowPrev = document.querySelector('#glider__prev-control'),
          gliderArrowNext = document.querySelector('#glider__next-control'),
          topPickCardEl = document.getElementsByClassName('glider-slide'),
          showOnDesktop = false;

    new GliderCarousel(topPicksEl, gliderArrowsEl, gliderDotsEl, gliderArrowPrev, gliderArrowNext, topPickCardEl, showOnDesktop);
  }

  const featuredEl = document.getElementById("glider-featured");
  if(featuredEl) {
    // Create Mobile Top Picks Carousel
    const gliderArrowsEl2 = document.getElementsByClassName('glider__controller'),
          gliderDotsEl2 = document.querySelector('#dots2'),
          gliderArrowPrev2 = document.querySelector('#glider__prev-control2'),
          gliderArrowNext2 = document.querySelector('#glider__next-control2'),
          topPickCardEl = document.getElementsByClassName('glider-slide'),
          showOnDesktop = false;

    new GliderCarousel(featuredEl, gliderArrowsEl2, gliderDotsEl2, gliderArrowPrev2, gliderArrowNext2, topPickCardEl, showOnDesktop);
  }

  // Init Header
  new Header(searchInputEl, formExpandEl, mobileSearchTitleEl, mobileSearchInputEl, closeMobileFormEl, searchFormEl, searchIconEl, documentBodyEl);
  // Init Search Refinement Filters
  new RefineSearch(refineEl, refineCloseEl, drawerEl, SHOW_REFINEMENT_CLASS);

  if(publicationEl) {
    new Choices(publicationEl, {shouldSort: false, itemSelectText: ''});
  }

  attachOnSelectChangeUrlHandler('[data-interaction-sort]');
  attachOnSelectChangeUrlHandler('[data-interaction-per-page]');

  utils();

  var isMobile = {
    Android: function() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
      return navigator.userAgent.match(/iPhone|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };

  if (!isMobile.any()) {
    new DatePicker();
  }

  Responsive()
  // @FIXME: Is this module good to re-import?
  //autosize(document.querySelectorAll('textarea'));
  RecentNotices(window.recentNotices || []);
  FixedFeedbackButton();
  Cards()


  // Remove preload class to start css animations at the same time
  document.querySelectorAll('.preload').forEach(x => x.classList.remove('preload'));
  FeatureBar()
}
